import {
    Container,
    Grid,
    Typography,
    Paper,
    IconButton,
    Tooltip,
    Divider
} from '@material-ui/core'
import {FilterList, ArrowForward} from "@material-ui/icons";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React, { ReactElement} from 'react'
import { globalStyles } from '../../assets/globalStyles';
import { useStyles } from './filterStyles';
import ZeitFilter from './zeit';
import MessstellenFilter from './messstellen'
import KenngroesseFilter from './kenngroesse';

export default function Filter(): ReactElement {

    const [selectedTab, setSelectedTab] = React.useState("zeit");
    const [filter, openFilter] = React.useState(false);

    const classes = {
        ...globalStyles(),
        ...useStyles()
    };

    return (
        < div >
            <Container maxWidth={false} style={{ marginTop: "10px" }}>
                <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item md={3} />
                    <Grid item md={6}>
                        <Typography color="primary" variant="h5">
                            Überschrift
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
            <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }} >
                <form className={classes.root} noValidate autoComplete="off" style={{ marginBottom: "10px" }}>
                    <div>
                        <Grid container spacing={4} style={{ marginBottom: "10px" }} >
                            <Grid item md={4} style={{ paddingLeft: "16px" }}>
                                <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"} style={{ marginLeft: "8px" }} >
                                    Sub-Überschrift 2
                                </Typography>
                            </Grid>
                            {filter ? 
                            <React.Fragment> 
                                <Grid container md={8} style={{ paddingTop: "5px", paddingBottom: "24px", paddingRight: "24px", justifyContent: "end" }}>
                                <Grid container md={1} style={{ paddingTop: "25px", paddingRight: "24px",justifyContent: "end" }}>
                                    <Divider orientation="vertical" flexItem />
                                </Grid>
                                <Grid item container md={5}>
                                <Grid item md={12} style={{textAlign: "end"}}>
                                    <IconButton onClick={() => openFilter(false)}>
                                        <Tooltip title="Filter zuklappen">
                                        <ArrowForward  />
                                        </Tooltip>
                                    </IconButton>
                                    </Grid>
                                    <Grid item md={12} style={{ paddingLeft: "16px" }}>
                                    
                                    <Tabs 
                                        value={selectedTab} 
                                        onChange={(event, value) => setSelectedTab(value)}
                                        indicatorColor="secondary"
                                        textColor="secondary"
                                        TabIndicatorProps={{
                                        style: {
                                            height: "5px",
                                        }
                                        }}
                                        >
                                        <Tab fullWidth={true} style={{width:"33%"}} label="Zeit" value="zeit"/>
                                        <Tab fullWidth={true} style={{width:"33%"}} label="Messstelle" value="messstelle"/>
                                        <Tab fullWidth={true} style={{width:"34%"}} label="Kenngröße" value="kenngroesse"/>
                                    </Tabs>
                                    <Grid item md={12} style={{ padding: "16px" }}/>
                                    {selectedTab=="zeit" ? <ZeitFilter />  : ""} 
                                    {selectedTab=="messstelle" ? <MessstellenFilter name={""}/> : ""}
                                    {selectedTab=="kenngroesse" ? <KenngroesseFilter name={""}/> : ""}
                                </Grid>
                                </Grid>
                                </Grid>
                            </React.Fragment>
                            :
                            <Grid container md={8} style={{ paddingTop: "5px", paddingBottom: "24px", paddingRight: "24px", justifyContent: "end" }}>
                            <Grid item md={12} style={{textAlign: "end"}}>
                            <IconButton onClick={() => openFilter(true)}>
                                <Tooltip title="Filter aufklappen">
                                <FilterList />
                                </Tooltip>
                            </IconButton>
                            </Grid>
                            </Grid>
                            }
                        </Grid>
                    </div>
                </form>
            </Paper>
        </div >
    );
}